export default {
	methods: {
		isInvalidEmail(value) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return !re.test(String(value).toLowerCase());
		},
		isEmpty(value) {
			return value == null || value.toString().trim() === '';
		},
		isSame(val1, val2) {
			return val1 === val2;
		},
	},
};
